import React from "react";

import { Header } from "../../components/Header";
import { SolutionBuildIdaasBanner } from "../../blocks/solution-build-idaas-banner";
import { BuildIdaasNeed } from "../../blocks/solution-build-idaas-need";
import { BuildIdaasBuyWay } from "../../blocks/solution-build-idaas-buy-way";
import { BuildIdaasService } from "../../blocks/solution-build-idaas-service";
import { BuildIdaasTable } from "../../blocks/solution-build-idaas-table";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { SolutionConsult } from "../../blocks/common-solution-consult";
import { Footer } from "../../components/Footer";
// import { CommonLinkPage } from "../../blocks/common-link-page";

export const BuildIdaasPage = () => {
  const { t } = useTranslation();
  return (
    <div className="build-idaas-page">
      <Header mode="light" />
      <SolutionBuildIdaasBanner
        title={t("solution.buildIdaas.title")}
        subtitle={t("solution.buildIdaas.subtitle")}
        imgurl="//files.authing.co/authing-website/solution-scene-banner.svg"
      />
      <BuildIdaasNeed />
      <BuildIdaasBuyWay />
      <BuildIdaasService />
      <BuildIdaasTable />
      {/* <CommonLinkPage pagesLink={pagesLink} /> */}
      <SolutionConsult />
      <Footer />
    </div>
  );
};
